import { FreelanceTalentPage } from 'features/freelance-talent/FreelanceTalentPage';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { config } from 'utils/config';

export default FreelanceTalentPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'freelance-talent'
      ])),
      baseUrl: config.appUrl,
      bannerText: '', // Placeholder
      testimonials: [] // Placeholder
    },
    revalidate: 30
  };
};
